import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Loading from "../../../../components/Loading";
import styles from './Compose.module.scss';
import commonStyles from "../common.module.scss";
import { useRouter } from "next/router";
import DockerComposePreview from "./components/DockerComposePreview";
import ActionsLayout from "../_layouts/ActionsLayout";
import { createBuilderDeployment } from "../_fetch/deployment/create";

function Compose({
                     modified,
                     project,
                     projectsStatus,
                     compose,
                     onDeploy,
                     userFetchStatus,
                     messages,
                     requestLoading,
                     user,
                     currentCloud,
                     token,
                     rerouteCondition,
                     rerouteToDefaults,
                 }) {

    const router = useRouter();

    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        if (router.isReady) setRefresh(true);
    }, [router.isReady, router.query.project]);

    useEffect(() => {
        if (!!refresh) setTimeout(() => setRefresh(false), 1);
    }, [refresh]);

    useEffect(() => {
        if (rerouteCondition) rerouteToDefaults();
    }, [rerouteCondition])

    if (!!refresh || userFetchStatus !== 'success' && !user) return (
        <Loading
            className={commonStyles.loading}
            icon={{faCode: 'fas fa-chevron-down', animationType: 'bottom'}}
            message={'Loading project...'}
            type={'component'}
            coverOpacity={0}
        />
    );

    const errors = messages.some(m => m.type === 'error');

    if (!compose) return null;

    return (
        <>
            <div className={styles.layout}>
                <div className={styles.layout__content}>
                    <h2 className={commonStyles.title}>Docker-compose</h2>
                    <DockerComposePreview composeData={compose}/>
                </div>
            </div>
            <ActionsLayout
                nextIcon={'fas fa-cloud-upload-alt'}
                nextTitle={`Deploy`}
                loading={requestLoading}
                nextType={'button'}
                nextDisabled={
                    !!requestLoading
                    || errors
                    || modified
                    || projectsStatus !== 'success'
                    || !project
                    || !!compose && !currentCloud
                }
                nextOnClick={() => {
                    createBuilderDeployment({
                        projectID: project.id,
                        tokenID: token?.id || undefined,
                        onSuccess: () => {
                            onDeploy()
                        }
                    })
                }}
                disabledGlobal={requestLoading}
            />
        </>
    )
}

const mapStateToProps = state => ({
    userFetchStatus: state.userData.userFetchStatus,
    user: state.userData.user,
    requestLoading: state.deployment.requestLoading,
    messages: state.deployment.messages,
    currentCloud: state.deployment.currentCloud,
});

export default connect(mapStateToProps)(Compose)